module.exports = __webpack_public_path__ + "img/am.6deb3e7d.svg";